// src/components/AddTestPopup.js
import React, { useState, useEffect } from "react";
import './AddtestPopup.css';
import Dropdown from "react-dropdown";
import DeleteIcon from "../../../../Setting/SettingsAssets/Delete.svg";
import searchIcon from "./Assets/Search.png";
import { useApp } from "../../../../../AppProvider";
import logger from "../../../../../utils/logger";

const AddTestPopup = ({ setIsTestModalOpen }) => {
  const { searchTestLab, setSearchTestLab, mediTableContentLabTest, setMediTableContentLabTest, searchQueryLab,
    setSearchQueryLab, fetchSearchTestLabAPI, medicationGroup, selectedPatientObj } = useApp();
  const [addTestLabOption, setAddtestLabOption] = useState();

  // console.log("searchTestLab in popup", searchTestLab)
  // console.log("mediTableContentLabTest in popup", mediTableContentLabTest)

  const handleDeleteClick = (serialNo) => {
    const updatedMediTableContent = mediTableContentLabTest.filter(
      (item) => item.serialNo !== serialNo
    );
    setMediTableContentLabTest(
      updatedMediTableContent.map((item, index) => ({
        ...item,
        serialNo: (index + 1).toString()
      }))
    );
  };

  const handleResultClick = (item) => {
    setSearchTestLab([]);
    setSearchQueryLab(item._id);
    const newLabTest = {
      serialNo: (mediTableContentLabTest.length + 1).toString(),
      Id: item._id,
      department: item.department,
      test: item.canonicalName
    };
    setMediTableContentLabTest([...mediTableContentLabTest, newLabTest]);
    setSearchQueryLab('');
  };


  const labTestGroupOptions = medicationGroup.map(group => ({
    label: group.groupName,
    value: group._id
  }));

  const handleDropdownChange = (option) => {
    setAddtestLabOption(option.value);
    const selectedGroup = medicationGroup.find(group => group._id === option.value);
    if (selectedGroup) {
      // doctorAdviceSection(selectedGroup);
      const newTableContent = selectedGroup.tests.map((item, index) => ({
        serialNo: (index + 1).toString(),
        department: item.department,
        testId: item._id,
        test: item.test,
      }));
      logger.debug("newTableContent", newTableContent)
      setMediTableContentLabTest(newTableContent);
    }
  }

  useEffect(() => {
    if (searchQueryLab.length >= 3) {
      fetchSearchTestLabAPI(searchQueryLab);
    } else {
      setSearchTestLab([]);
    }
  }, [searchQueryLab, fetchSearchTestLabAPI]);


  const handleSearchLabChange = (event) => {
    const query = event.target.value;
    setSearchQueryLab(query);
  };

  // console.log("searchTestLab", searchTestLab)

  return (
    <div className="test-overlay_page">
      <div className="test-main-container">
        <h2 className="test-main-container-heading">Add Tests</h2>
        <div className="test-input-type-search">
          <div className="test-search-container">
            <img src={searchIcon} className="test-search-icon" alt="search" />
            <input
              className="test-input-type-align"
              type="text"
              placeholder="search Test"
              value={searchQueryLab}
              onChange={handleSearchLabChange}
            />
            {searchTestLab.length > 0 && (
              <div className="test__search-result">
                {searchTestLab.map((item, index) => (
                  <div className="test__search" key={index}
                    onClick={() => handleResultClick(item)} >
                    {item.canonicalName}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="test-search-container">
            <Dropdown
              controlClassName="my-dropdown-control_groups"
              options={labTestGroupOptions}
              onChange={handleDropdownChange}
              value={addTestLabOption}
              placeholder="Select Test Group"
            />
          </div>
        </div>
        <div className="test-table-wrapper">
          <table className="test-table">
            <thead>
              <tr className="test-tableheader">
                <th className="test-header_text">S.No.</th>
                <th className="test-header_text add-testnameWidth">Test Name</th>
                <th className="test-header_text add-testnameWidth">Department Name</th>
                <th className="test-header_text delete-test-icon">Delete</th>
              </tr>
            </thead>
            <tbody>
              {mediTableContentLabTest.length > 0 ? (
                mediTableContentLabTest.map((group) => (
                  <tr key={group.serialNo}>
                    <td className="test-table_el">{group.serialNo}</td>
                    <td className="test-table_el">{group.test}</td>
                    <td className="test-table_el">{group.department || <span>Lab name not Avilable</span>}</td>
                    <td className="test-table_el test-delete-icon">
                      <img
                        className="test-delete_icon"
                        src={DeleteIcon}
                        alt="deleteicon"
                        onClick={() => handleDeleteClick(group.serialNo)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="test-no_tests_selected">
                    No Tests Selected
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="test-bottom-button-div">
          <button className="test-bottom-button test-bottom-button-right" onClick={() => { setIsTestModalOpen(false); setSearchQueryLab('') }}>Cancel</button>
          <button className="test-bottom-button test-bottom-button-left" onClick={() => setIsTestModalOpen(false)}>Add Test</button>
        </div>
      </div>
    </div>
  );
};

export default AddTestPopup;